<template>

  <vuestic-navbar>
    <header-selector slot="selector" :isOpen.sync="valueProxy"/>
    <span slot="logo" class="i-vuestic-stsc-long"></span>
    <!--<span slot="center">
      {{$t('navbar.messageUs')}}&nbsp;<a href="mailto:admin@smashtheshuttlecock.info">admin@smashtheshuttlecock.info</a>
    </span>-->
    <message-dropdown/>
    <notification-dropdown/>
    <language-dropdown/>
    <profile-dropdown>
      <img src="/static/img/avatars/011-dragon-1.png"/>
    </profile-dropdown>
  </vuestic-navbar>

</template>

<script>
  import VuesticNavbar from '../../../vuestic-theme/vuestic-components/vuestic-navbar/VuesticNavbar'
  import HeaderSelector from './components/HeaderSelector'
  import LanguageDropdown from './components/dropdowns/LanguageDropdown'
  import ProfileDropdown from './components/dropdowns/ProfileDropdown'
  import NotificationDropdown from './components/dropdowns/NotificationDropdown'
  import MessageDropdown from './components/dropdowns/MessageDropdown'

  export default {
    name: 'app-navbar',

    components: {
      VuesticNavbar,
      HeaderSelector,
      MessageDropdown,
      NotificationDropdown,
      LanguageDropdown,
      ProfileDropdown
    },

    props: {
      isOpen: {
        type: Boolean,
        required: true
      }
    },
    computed: {
      valueProxy: {
        get () {
          return this.isOpen
        },
        set (opened) {
          this.$emit('toggle-menu', opened)
        },
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/admin/app-navbar/AppNavbar.vue